import React, { useState } from "react";

interface Props {
  initData?: {
    title: string;
    desc: string;
  };
  isLastEntry?: boolean;
  removeDepositPolicy?: (index: number) => void;
  addDepositPolicy?: (payload: { title: string; desc: string }) => void;
  updateDepositPolicy?: (
    index: number,
    key: "title" | "desc",
    value: string
  ) => void;
  index?: number;
}
function DepositPolicy({
  initData,
  isLastEntry = true,
  addDepositPolicy,
  removeDepositPolicy,
  updateDepositPolicy,
  index,
}: Props) {
  const [title, setTitle] = useState(initData?.title ?? "");
  const [desc, setDesc] = useState(initData?.desc ?? "");

  function handleAdd(e: React.MouseEvent) {
    e.preventDefault();
    if (
      !(title === initData?.title && desc === initData.desc) &&
      addDepositPolicy
    ) {
      addDepositPolicy({
        title,
        desc,
      });
      // Clear the form after adding
      setTitle("");
      setDesc("");
    }
  }

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTitle = e.target.value;
    setTitle(newTitle);
    if (index && typeof index === "number" && updateDepositPolicy) {
      updateDepositPolicy(index, "title", newTitle);
    }
  };

  const handleDescChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDesc = e.target.value;
    setDesc(newDesc);
    if (index && typeof index === "number" && updateDepositPolicy) {
      updateDepositPolicy(index, "desc", newDesc);
    }
  };

  return (
    <form className="flex gap-2">
      <div className="flex flex-col w-full gap-2">
        <div className="flex flex-col gap-2">
          <label className="text-xs">Title</label>
          <input
            className="w-full p-2 border-[2px] rounded-xl border-[#D9D9D9] bg-[#F7F7F7]"
            value={title}
            onChange={handleTitleChange}
          />
        </div>
        <div className="flex flex-col gap-2">
          <label className="text-xs">Description</label>
          <input
            className="w-full p-2 border-[2px] rounded-xl border-[#D9D9D9] bg-[#F7F7F7]"
            value={desc}
            onChange={handleDescChange}
          />
        </div>
      </div>
      <div className="flex flex-col justify-end">
        {isLastEntry ? (
          <button
            className="p-2 px-4 rounded-lg bg-blue-900 text-white flex items-center justify-center"
            onClick={handleAdd}
          >
            +
          </button>
        ) : (
          <button
            onClick={(e) => {
              e.preventDefault();
              if (removeDepositPolicy && index) {
                removeDepositPolicy(index);
              }
            }}
            className="p-2 px-4 bg-red-900 rounded-lg text-white flex items-center justify-center"
          >
            -
          </button>
        )}
      </div>
    </form>
  );
}

export default DepositPolicy;
